<template>
 <div>

     <v-dialog max-width="850" persistent v-model="customerDialog" scrollable>
         <v-card>
             <v-card-title class="text-h5 pl-3 font-weight-regular">{{form.id?'Update':'Create'}} Customer</v-card-title>
             <v-divider/>
             <v-card-text>
                 <v-form ref="form">
                     <v-row>
                         <div class="section-title mt-2">Personal Details</div>
                         <v-col cols="6">
                             <label class="text-uppercase grey--text font-weight-bold">Customer Name*</label>
                             <v-text-field :rules="[value => !!value || 'Customer Name Required']"
                                           class="mt-3" outlined v-model="form.name"/>
                         </v-col>
                         <v-col cols="6">
                             <label class="text-uppercase grey--text font-weight-bold">Sales Executive*</label>
                             <v-autocomplete outlined  class="mt-3" :items="salesExecutives"
                                             :rules="[value => !!value || 'Sales Executive Required']"
                                             v-model="form.salesExecutiveId" item-text="name" item-value="id"/>
                         </v-col>
                         <v-col cols="6">
                             <label class="text-uppercase grey--text font-weight-bold">Mobile*</label>
                             <v-text-field :rules="[value => !!value || 'Mobile Required',value => value && value.length === 10 || 'Must be 10 characters']"
                                           class="mt-3" outlined v-model="form.mobile" type="number"/>
                         </v-col>
                         <v-col cols="6">
                             <label class="text-uppercase grey--text font-weight-bold">Email*</label>
                             <v-text-field :rules="[value => !!value || 'Email Required', emailValid]"  class="mt-3"
                                           outlined v-model="form.email"></v-text-field>
                         </v-col>
                         <v-col cols="6">
                             <label class="text-uppercase grey--text font-weight-bold">Branch*</label>
                             <v-select outlined  class="mt-3" :items="activeBranches" :disabled="form.city&&form.city.toLowerCase().trim() !== 'surat'"
                                       v-model="form.defaultWarehouseId" item-text="name" item-value="id"/>
                         </v-col>
                         <v-col cols="6">
                             <label class="text-uppercase grey--text font-weight-bold">City*</label>
                             <v-autocomplete outlined  class="mt-3" :items="cities" :search-input.sync="searchCity"
                                             :rules="[value => !!value || 'City Required']" v-model="form.city" @change="onSelectCity"
                                             item-text="name" item-value="name" :loading="$apollo.queries.cities.loading"/>
                         </v-col>
                         <v-col cols="12"><v-divider/></v-col>

                         <div class="section-title">Company Details</div>
                         <v-col cols="6">
                             <label class="text-uppercase grey--text font-weight-bold">GST Number</label>
                             <v-text-field :rules="[v => !v || Constants.GstPattern.test(v) || 'Invalid GST Number']"
                                           class="mt-3" outlined v-model="form.gstNumber" ref="gst-number" maxlength="15"/>
                         </v-col>
                       <!--  <v-col cols="6">
                             <v-btn :disabled="!form.gstNumber || ($refs['gst-number']&&$refs['gst-number'].hasError)"
                                    class="primary mt-11" @click="verifyGst">Verify</v-btn>
                         </v-col> -->
                         <v-col cols="6">
                             <label class="text-uppercase grey--text font-weight-bold">Company Name*</label>
                             <v-text-field :rules="[v => !!v || 'Company Name Required']"
                                           class="mt-3" outlined v-model="form.companyName"/>
                         </v-col>
                       <!--  <v-col cols="12">
                             <label class="text-uppercase grey--text font-weight-bold">Address</label>
                             <div>Address line1, Area, city, state - pincode</div>
                         </v-col> -->
                     </v-row>
                 </v-form>
             </v-card-text>
             <v-card-actions class="mt-5">
                 <v-spacer></v-spacer>
                 <v-btn class="text-capitalize white elevation-0" text @click="closeDialog">Close</v-btn>
                 <v-btn class="primary px-3 text-capitalize" :loading="formLoading" dark @click="handleSubmit">Save</v-btn>
             </v-card-actions>
         </v-card>
     </v-dialog>

     <Snackbar :toaster="toaster"></Snackbar>
 </div>
</template>

<script>
import Constants from "../../Constants/Constants";
import Snackbar from "../../components/Common/Snackbar";
import {CREATE_UPDATE_CUSTOMER} from "../../graphql/mutations/Customers";
import {GET_ALL_CITIES, GET_CITY_DETAIL} from "../../graphql/queries/Territories";
import {debounce} from 'lodash'
import {GET_CUSTOMER_BY_ID} from "../../graphql/queries/Customers";
import {SUBSCRIBE_ACTIVE_BRANCHES} from "../../graphql/subscriptions/Branches";
import checkDuplication from '../../mixins/checkDuplication';
import {SUBSCRIBE_USERS_BY_TYPE} from "../../graphql/subscriptions/Users";
// import NetworkCommunicator from "../../plugins/NetworkResourceHandler";
let toaster = { enable:false, color:'green', message:'' };
let form = { id:null, name:'', type:'CUSTOMER', mobile:'', email:null, createdFrom:'WEB', salesExecutiveId:null,
    defaultWarehouseId :Constants.Warehouses.Katargam, city:null, status:'ACTIVE', companyName:'', gstNumber:null };
let creditForm = { creditLimit:Constants.CustomerCreditLimit, outstanding:0,  availableCredit:Constants.CustomerCreditLimit, dueDayLimit:10}
export default {
    name: "CustomerForm",
    components: {Snackbar},
    props: ['formDialog', 'id'],
    mixins: [checkDuplication],
    apollo: {
        $subscribe: {
            activeBranches: { query: SUBSCRIBE_ACTIVE_BRANCHES,
                result ({ data}) { this.activeBranches = data.activeBranches }},
            Users: { query: SUBSCRIBE_USERS_BY_TYPE,
                      variables(){ return{ roleId: Constants.UserRoles.SalesExecutive } },
                      result ({ data}) { this.salesExecutives = data.Users }
            },
        },
        cities: {
            query: GET_ALL_CITIES,
            variables(){ return{ city: '%' +this.filterCity+ '%' } }
        },
        customer: {
            query: GET_CUSTOMER_BY_ID,
            fetchPolicy: 'network-only',
            skip () {return !this.id},
            variables(){ return{ id: this.id } },
            result ({data}) {
                Object.copyExistingKeys(this.form, data.customer[0])
                Object.copyExistingKeys(this.creditForm = {...creditForm, id:''}, data.customer[0].CustomerCreditDetail)
                this.filterCity = this.form.city
                this.existingMobile = this.form.mobile                  //Not to check its own mobile While Edit Customer
            },
        },
    },
    data(){
        return{
            Constants: Constants,
            user: JSON.parse(localStorage.user),
            activeBranches: [],
            cities: [],
            form: {...form},
            creditForm: {...creditForm},
            formLoading: false,
            searchCity: null,
            filterCity: null,
            toaster: toaster,
            emailValid: v => v && Constants.EmailPattern.test(v) || 'E-mail must be valid',
            existingMobile: '',
            salesExecutives: []
        }
    },
    watch: {
        searchCity: debounce(function(val) {
            if(val?.length > 1) this.filterCity = val
        }, 500)
    },
    computed:{
        customerDialog(){
            return this.formDialog
        }
    },
    methods:{
       /* verifyGst(){
          NetworkCommunicator('GET', `http://sheet.gstincheck.ml/check/4219f4dcac523cd1cfea59834b4a33ee/${this.form.gstNumber}`).then(response => {
              console.log(response)
          }).catch(e => console.log('checkGst error', e));
        }, */
        onSelectCity(val){
            if(val && val.toLowerCase().trim() !== 'surat'){
                this.form.defaultWarehouseId = Constants.Warehouses.Katargam;
            }
        },
        handleSubmit(){
            if(this.$refs.form.validate()){
                this.creditForm.customerId = this.form.id = this.form.id || Constants.generateUUID();   //chaining assignment
                this.saveCustomer()
            }
        },
        async checkMobileExist(){
            if(this.form.mobile === this.existingMobile) return;
            let condition = { mobile: { _eq: this.form.mobile }}
            if(await this.checkDuplication('Customers', condition)){
                this.toaster = { enable: true, color: 'red', message: 'Mobile \''+this.form.mobile+'\' already exists !'}
                this.formLoading = false
                return true
            }
        },
        async getCityDetails(city){
            let response = await this.$apollo.query({
                query: GET_CITY_DETAIL,
                fetchPolicy: 'network-only',
                variables:{ city }
            })
            if(response.data.cities.length){
                return response.data.cities[0]
            }else{
               return  {city:null, state:null, country:null}
            }
        },
        async saveCustomer(){
            this.formLoading = true;
            if(await this.checkMobileExist()) return;
            let {city, state, country} = await this.getCityDetails(this.form.city);
            this.form.id = this.form.id || Constants.generateUUID();
            let response = await this.$apollo.mutate({
                mutation: CREATE_UPDATE_CUSTOMER,
                variables: {
                    customer: {
                        ...this.form,
                        gstNumber: this.form.gstNumber || null,
                        createdBy: this.user.id,
                        updatedBy: this.user.id
                    },
                    updateColumns: [...Object.keys(this.form), 'updatedBy'],
                    customerId: this.form.id,
                    customerAddress: {city, state, country},
                    credit: {
                        ...this.creditForm,
                        createdBy: this.user.id,
                        updatedBy: this.user.id
                    },
                    updateColumnsCredit: []
                }
            })
            this.formLoading = false
            this.toaster = {enable:true, color:'green', message: `Customer ${this.id?'updated':'added'} Successfully`}
            if(response.data) this.closeDialog()
        },
        closeDialog(){
            this.$refs.form.resetValidation()
            this.form = {...form}
            this.creditForm = {...creditForm}
            this.existingMobile = ''                  //Reset value
            this.$emit('closeDialog')
        }
    }
}
</script>

<style scoped>
.section-title{
    font-size: 20px;
    color: black;
    padding: 10px;
    width: 100%;
}
</style>
